// Session-scoped keys for in-progress catalog editor drafts (see useCatalogEditor).
// Mirrors activityDraftStorage.ts — needed for the same reason: navigating away to the
// product picker and back unmounts CatalogEditorPage, which would otherwise wipe the form.

export function getCreateCatalogDraftKey(companyId: number): string {
  return `create-catalog-state-${companyId}`;
}

export function getEditCatalogDraftKey(companyId: number, catalogId: number): string {
  return `edit-catalog-state-${companyId}-${catalogId}`;
}

export function clearCreateCatalogDraft(companyId: number): void {
  sessionStorage.removeItem(getCreateCatalogDraftKey(companyId));
}

export function clearEditCatalogDraft(companyId: number, catalogId: number): void {
  sessionStorage.removeItem(getEditCatalogDraftKey(companyId, catalogId));
}
